module.exports = __webpack_public_path__ + "static/media/arrow-point-to-down.af2fc82c.svg";